import React, { useEffect } from "react";
import RequestImage from "../assets/Images/email_verification.jpeg";
import Footer from "../components/Footer";
import { Stack, Typography, Container } from "@mui/material";
import Navbar from "../components/Navbar";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { emailVerification } from "../apis";

const EmailVerification = () => {
  const user = JSON.parse(localStorage.getItem("user-info"));
  const userID = user?.googleId ? user.googleId : user._id;
  const email = user.email;

  useEffect(() => {
    emailVerification({ email: email, id: userID });
  }, []);
  return (
    <>
      <Navbar />
      <Container>
        <div>
          <Stack className="d-flex">
            <Typography
              variant="h5"
              gutterBottom
              component="div"
              className="t-a-c"
            >
              We have sent a verification email
            </Typography>
            <Typography
              variant="body2"
              gutterBottom
              component="div"
              className="t-a-c"
            >
              Please verify the email to proceed further
              <br />
              Thank you.
            </Typography>
          </Stack>

          <div className="t-a-c">
            <img src={RequestImage} alt="MenuIcon" />
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default EmailVerification;
